import { Controller } from '@hotwired/stimulus';
import $ from 'jquery';


export default class extends Controller {
    static targets = [
        'cancelButton',
        'submitButton',
        'duration',
        'option',
        'otherOptionDescription',
        'firstConsultationPrice',
        'firstConsultationFreeIfCaseOpenedPrice',
    ];

    connect() {
        this.saveInitialState();

        this.element.addEventListener('show.bs.modal', () => {
            this.hideAllConditionalFields();
            this.resetValidationFields();
        });

        this.showRelevantFields();

        const waitForTomSelect = () => {
            if (this.durationTarget && this.durationTarget.tomselect) {
                this.durationTarget.tomselect.on('change', () => {
                    this.durationTarget.tomselect.close();
                    this.durationTarget.tomselect.control_input.blur();
                });
            } else {
                setTimeout(waitForTomSelect, 50);
            }
        };
        waitForTomSelect();
    }

    disconnect() {
        $(this.element).off('hidden.bs.modal');
    }

    showRelevantFields() {
        this.optionTargets.forEach(option => {
            if (option.checked) {
                this.handleOptionDisplay(option);
            }
        });
    }

    openModal() {
        $(this.element).modal({
            backdrop: 'static',
            focus: false,
            show: true,
        });
    }

    closeModal() {
        this.restoreInitialState();
        this.resetValidationFields(); // Clear any error messages when closing the modal
        $(this.element).modal('hide');
    }

    optionSelected(event) {
        const option = event.target;
        this.hideAllConditionalFields();
        this.handleOptionDisplay(option);
    }

    async submitForm() {
        this.submitButtonTarget.disabled = true;
        this.cancelButtonTarget.disabled = true;

        showPreloader();

        const data = this.collectFormData();

        const { option, description } = JSON.parse(data.value);

        if (option === 'other' && description.trim().length === 0) {
            addAlert('danger', translations['profile.Please fill in your conditions']);
            this.submitButtonTarget.disabled = false;
            this.cancelButtonTarget.disabled = false;
            hidePreloader();
            return;
        }

        try {
            const response = await fetch(routes['app_profile_firstappointmentoptions'], {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
                    'X-Requested-With': 'XMLHttpRequest',
                },
                body: new URLSearchParams(data),
            }).then(res => res.json());

            if (response.status) {
                dataLayer.push({
                    event: 'dataLayer.gaEvent',
                    gaEvent: {
                        'category': 'Account',
                        'action': 'profile_1st_appointment_modification',
                        'label': GA_EVENT_LABEL,
                    },
                });

                window.location.reload();
            } else {
                if (response.message) {
                    if (response.violations) {
                        this.resetValidationFields(); // Reset validation before showing new errors
                        response.violations.forEach(violation => {
                            if ('paidConsultationPrice' === violation.field) {
                                this.firstConsultationPriceTarget.querySelector('.invalid-feedback').textContent = violation.message;
                                this.firstConsultationPriceTarget.querySelector('.invalid-feedback').style.display = 'block';
                            }

                            if ('freeWhenCaseOpenedPrice' === violation.field) {
                                this.firstConsultationFreeIfCaseOpenedPriceTarget.querySelector('.invalid-feedback').textContent = violation.message;
                                this.firstConsultationFreeIfCaseOpenedPriceTarget.querySelector('.invalid-feedback').style.display = 'block';
                            }
                        });
                    }
                    addAlert('danger', response.message);
                    this.submitButtonTarget.disabled = false;
                    this.cancelButtonTarget.disabled = false;

                    hidePreloader();
                } else {
                    addAlert('danger', translations['profile.An unknown error occurred.']);
                    this.submitButtonTarget.disabled = false;
                    this.cancelButtonTarget.disabled = false;

                    hidePreloader();
                }
            }
        } catch (error) {
            console.error(error);

            addAlert('danger', translations['profile.An unknown error occurred.']);

            this.submitButtonTarget.disabled = false;
            this.cancelButtonTarget.disabled = false;

            hidePreloader();
        }
    }

    hideAllConditionalFields() {
        this.otherOptionDescriptionTarget.style.display = 'none';
        this.firstConsultationPriceTarget.style.display = 'none';
        this.firstConsultationFreeIfCaseOpenedPriceTarget.style.display = 'none';
    }

    handleOptionDisplay(option) {
        if (option.value === 'other') {
            this.otherOptionDescriptionTarget.style.display = 'block';
        }
        if (option.value === 'paid') {
            this.firstConsultationPriceTarget.style.display = 'block';
        }
        if (option.value === 'free-when-case-opened') {
            this.firstConsultationFreeIfCaseOpenedPriceTarget.style.display = 'block';
        }
    }

    restoreInitialState() {
        this.hideAllConditionalFields();

        this.optionTargets.forEach((option, index) => (option.checked = this.initialState.options[index]));
        const tomSelectInstance = this.durationTarget.tomselect;
        tomSelectInstance.setValue(this.initialState.duration);
        this.otherOptionDescriptionTarget.querySelector('#free-consultation-other-description').value = this.initialState.otherDescription.trim();
        this.firstConsultationPriceTarget.querySelector('#first-consultation-price').value = this.initialState.paidPrice;
        this.firstConsultationFreeIfCaseOpenedPriceTarget.querySelector('#first-consultation-free-if-case-opened-price').value = this.initialState.freeWhenCaseOpenedPrice;

        this.showRelevantFields();
    }

    saveInitialState() {
        this.initialState = {
            options: this.optionTargets.map(option => option.checked),
            duration: parseInt(this.durationTarget.value),
            otherDescription: this.otherOptionDescriptionTarget.querySelector('#free-consultation-other-description').value.trim(),
            paidPrice: this.firstConsultationPriceTarget.querySelector('#first-consultation-price').value ? parseInt(this.firstConsultationPriceTarget.querySelector('#first-consultation-price').value) : null,
            freeWhenCaseOpenedPrice: this.firstConsultationFreeIfCaseOpenedPriceTarget.querySelector('#first-consultation-free-if-case-opened-price').value ? parseInt(this.firstConsultationFreeIfCaseOpenedPriceTarget.querySelector('#first-consultation-free-if-case-opened-price').value) : null,
        };
    }

    collectFormData() {
        const option = this.optionTargets.find(option => option.checked)?.value;
        const data = {
            field: 'first-appointment',
            value: {
                option: option,
                duration: parseInt(this.durationTarget.tomselect.getValue()),
            },
        };

        if (option === 'other') {
            data.value.description = this.otherOptionDescriptionTarget.querySelector('#free-consultation-other-description').value.trim();
        }
        if (option === 'paid') {
            data.value.paidConsultationPrice = this.firstConsultationPriceTarget.querySelector('#first-consultation-price').value ? parseInt(this.firstConsultationPriceTarget.querySelector('#first-consultation-price').value) : null;
        }
        if (option === 'free-when-case-opened') {
            data.value.freeWhenCaseOpenedPrice = this.firstConsultationFreeIfCaseOpenedPriceTarget.querySelector('#first-consultation-free-if-case-opened-price').value ? parseInt(this.firstConsultationFreeIfCaseOpenedPriceTarget.querySelector('#first-consultation-free-if-case-opened-price').value) : null;
        }

        data.value = JSON.stringify(data.value);

        return data;
    }

    resetValidationFields() {
        // Hide all invalid feedback and reset validation styles
        this.otherOptionDescriptionTarget.querySelector('.invalid-feedback').style.display = 'none';
        this.firstConsultationPriceTarget.querySelector('.invalid-feedback').style.display = 'none';
        this.firstConsultationFreeIfCaseOpenedPriceTarget.querySelector('.invalid-feedback').style.display = 'none';

        // Reset text content of invalid feedback
        this.otherOptionDescriptionTarget.querySelector('.invalid-feedback').textContent = '';
        this.firstConsultationPriceTarget.querySelector('.invalid-feedback').textContent = '';
        this.firstConsultationFreeIfCaseOpenedPriceTarget.querySelector('.invalid-feedback').textContent = '';
    }
}
